import { useCallback, useEffect } from 'react'
import * as React from 'react'

import { Close } from '../../atoms/close'
import {
  CurrentStepNumber,
  Header,
  ProgressBar,
  ProgressNumbers,
  Title,
  TitleWrapper,
  Wrapper
} from './primitives'

export type ProgressContainerProps = {
  children: React.ReactNode
  currentStep: number
  numSteps: number
  onClickClose: () => void
  title: string
}

export function ProgressContainer({
  children,
  currentStep,
  numSteps,
  onClickClose,
  title
}: ProgressContainerProps) {
  const escFunction = useCallback(
    event => {
      if (event.keyCode === 27) {
        onClickClose()
      }
    },
    [onClickClose]
  )

  useEffect(() => {
    document.addEventListener('keydown', escFunction, false)
    return () => {
      document.removeEventListener('keydown', escFunction, false)
    }
  }, [escFunction])

  const percent = (currentStep / numSteps) * 100
  return (
    <Wrapper>
      <ProgressBar percent={percent} />
      <Header>
        <TitleWrapper>
          <ProgressNumbers>
            <CurrentStepNumber>{currentStep}</CurrentStepNumber>/{numSteps}
          </ProgressNumbers>
          <Title>{title}</Title>
        </TitleWrapper>
        <Close onClick={() => onClickClose()} />
      </Header>
      <div>{children}</div>
    </Wrapper>
  )
}
